import { render, staticRenderFns } from "./DetalhesSolicitacaoModal.vue?vue&type=template&id=20c9bccd&scoped=true&"
import script from "./DetalhesSolicitacaoModal.vue?vue&type=script&lang=js&"
export * from "./DetalhesSolicitacaoModal.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesSolicitacaoModal.vue?vue&type=style&index=0&id=20c9bccd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c9bccd",
  null
  
)

export default component.exports